/**
 * Wraps Chinese characters and punctuation in a span for specific styling.
 * Supports Han script and CJK full-width punctuation.
 */
export const wrapMixedText = (text) => {
  if (!text) return "";

  // Unicode ranges:
  // \u3000-\u303F: CJK Symbols and Punctuation (。，、)
  // \uFF00-\uFFEF: Halfwidth and Fullwidth Forms (（）！：)
  // \p{Script=Han}: Any Chinese character
  const chineseRegex = /([\u3000-\u303F\uFF00-\uFFEF\p{Script=Han}]+)/gu;

  return text.split(chineseRegex).filter(Boolean).map((part, index) => {
    const isChinese = /[\u3000-\u303F\uFF00-\uFFEF\p{Script=Han}]/u.test(part);

    if (isChinese) {
      return (
        <span key={index} className="zh-font">
          {part}
        </span>
      );
    }
    return part;
  });
};